import { VimeoPlayerProps } from "@bluebottlecoffee/design-system";
import { VimeoPlayer as Schema } from "../sanity-schema";

export function toVimeoPlayerProps(data: Schema): VimeoPlayerProps {
  return {
    vimeoPlayerUrl: data.vimeoUrl,
  };
}
